/**
 * Centralized API version breakpoints for GraphQL requests.
 * Format: YYYYMMDD (e.g., "20260123")
 *
 * This module provides a single source of truth for API version constants,
 * making it easy for clients (web, mobile apps, etc.) to reference what
 * features are available at each version breakpoint.
 *
 * The X-API-Version header is validated in api/src/graphql/context.js
 * and forwarded to Armageddon for feature gating.
 *
 * When adding new version constants:
 * 1. Use descriptive names that indicate what feature was introduced
 * 2. Add a comment explaining what changed at this version
 * 3. Use YYYYMMDD format for the version string
 * 4. Keep constants in chronological order (newest at bottom)
 *
 * @see Rest::ApiVersions module in Armageddon for corresponding backend constants
 */

/**
 * Version when outlet collections were introduced to product collections.
 * Clients with api_version >= this date will receive outlet collections in responses.
 * Introduced: January 23, 2026
 */
export const OUTLETS_RELEASE = '20260123';

/**
 * Admin apps should always see all features for management purposes.
 * This is set to a far future date (Dec 31, 2100) to ensure admins
 * see all feature-gated content regardless of when features are released.
 */
export const ADMIN_ALWAYS_LATEST = '21001231';
